import React, { useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { userService } from '../../../../services/user.service';

const StatusChangeModal = ({ user, onClose, onSuccess }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleStatusChange = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await userService.updateUserStatus(user._id, !user.isActive);
      
      if (response?.status === 'success' && response.data?.user) {
        onSuccess(user._id, !user.isActive);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Status change error:', err);
      setError(err.message || 'Failed to update user status');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-medium">Change User Status</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            ×
          </button>
        </div>
        
        {error && (
          <div className="mb-4 bg-red-50 border-l-4 border-red-400 p-4">
            <div className="flex">
              <AlertCircle className="h-5 w-5 text-red-400" />
              <p className="ml-3 text-sm text-red-700">{error}</p>
            </div>
          </div>
        )}

        <p className="text-gray-600 mb-6">
          Are you sure you want to {user.isActive ? 'deactivate' : 'activate'} this user?
          {user.isActive 
            ? ' This will prevent them from accessing the system.'
            : ' This will restore their access to the system.'}
        </p>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleStatusChange}
            disabled={loading}
            className={`px-4 py-2 text-sm text-white rounded-md flex items-center ${
              user.isActive 
                ? 'bg-red-600 hover:bg-red-700' 
                : 'bg-green-600 hover:bg-green-700'
            } disabled:opacity-50`}
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                Processing...
              </>
            ) : (
              user.isActive ? 'Deactivate' : 'Activate'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusChangeModal;